function displaySlider(modal) {
    modal.open();
}

function createModal () {       
  var modal = new Custombox.modal({
  // Options
  content: {
    target: '#slideup',
    effect: 'slide',
    close: false,
    clone: false,
    animateFrom: 'bottom',
    animateTo: 'bottom',
    positionX: 'center',
    positionY: 'bottom',
    width: '100%',
    speedIn: 300,
    speedOut: 300,
    delay: 250,
    fullscreen: false,
    onOpen: null,
    onComplete: null,
    onClose: null,
  },
  overlay: {
    active: false,
  },
  loader: {
    active: true,
    color: '#000',
    speed: 1500,
  },
});
  
var countdownTarget = localStorage.getItem('countdownTarget');    // Read from storage.
  if(countdownTarget < (new Date()).getTime()) {
    localStorage.removeItem('countdownTarget');

  }

if (countdownTarget === null) {                                   // Not stored?
  displaySlider(modal);
  countdownTarget = ((new Date()).getTime() + parseInt(24)*60*60*1000);  // Make a new one.
  localStorage.setItem('countdownTarget', countdownTarget);     // Store it.
}
  else {
    Custombox.modal.closeAll();
  }
}

$(function () {
  $(".slideup-closer").click(function() {
  Custombox.modal.closeAll();
  })
})

$(document).ready(function() {
  
})

function tempCartHover () {
    $("#new-cart").slideDown('fast');
  setTimeout(function(){
    if(!$("#new-cart").is(":hover")){
    $("#new-cart").slideUp('fast');
    }
  }, 5000)
}

$(window).scroll(function(){
  if(!$("#new-cart").is(":hover")){
  $("#new-cart").slideUp('fast');
  }
})

// Menu Hover Animation
 $(function ()
    {
  $(".menu li").mouseover(function () {
        $(this).find(".dropdown").slideDown('fast');
    });
  $(".menu li").mouseleave(function ()
    {
        $(this).find(".dropdown").slideUp('fast');
    });;
 });

$(function() {

  var allPanels = $('.accordion > dd').hide();
    
  $('.accordion > dt > a').click(function() {
    if(!$(this).parent().next().is(":visible")) {
    allPanels.slideUp();
    $('.accordion small.right').html('&#9668;');
     $(this).find('small.right').html('&#9660;');
    $(this).parent().next().slideDown();
    }
        return false;
  });
  
/* removed 7/31/18 as freegeoip.net now requires API key and this is 404'ing.  Believe inserted via manual code snippet likely for currency switcher app ages ago.  https://ecommerce.shopify.com/c/shopify-discussion/t/auto-change-currency-based-on-location-tutorial-179134
  
jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'GET',
  dataType: 'jsonp',
  success: function(location) {
    if (location.country_code == 'US') { // Default shop currency
      $('[name=currencies] [value=USD]').attr('selected', 'selected');
    } else if (location.country_code == 'UK') { // Secondary currency
     $('[name=currencies] [value=GBP]').attr('selected', 'selected');
    } else { // Fallback currency
      $('[name=currencies] [value=EUR]').attr('selected', 'selected');
    }
    // Let the scripts in 'currencies.liquid' handle the rest
    $('[name=currencies]').change();
  }
} );
  
*/
  
  $($('.accordion dd')[0]).show();
  $(".thumbnail img, .product_slider img, .cart_page_image img").unveil(200);

  $('#homepage_slider').flexslider({
    touch: true, 
    
    controlNav: true,
     
      directionNav: true, 
    
    animation: "fade", 
    
    slideshowSpeed: 6*1000 
  });

  var $header = $(".index .header");
  
    if ($(window).width() >= 768) {
      $('.logo img', $header).attr('src', $('.logo img').data('src-home'));
    } else {
      $('.logo img').attr('src', $('.logo img').data('src'));
    }
  

  
    $(window).on("scroll", function() {
      if(!$('html').hasClass('mm-opened')) {
        $header.toggleClass('header_bar', $(window).scrollTop() > 0);
        
          if($(window).width() >= 768) {
            if($(window).scrollTop() > 0) {
              $('.logo img', $header).attr('src', $('.logo img').data('src'));
            } else {
              $('.logo img', $header).attr('src', $('.logo img').data('src-home'));
            }
          }
        
      }
    });
  


  $('.search_link').on("click", function(){
    $(this).attr("href", $(this).attr("href") + $(".mm-search input").val());  
  })


  if($('#homepage_slider img').length == 1) { $('#homepage_slider .flex-direction-nav').hide() }

  $('.slider').flexslider({touch: false, controlNav: false, animation: "fade" });
  
  $('.slider-no-nav').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade" });

  $('.slider-no-nav-quick').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade", slideshowSpeed: 4000 });

  $('.product_slider').flexslider({
    startAt: parseInt($('.featured_image', $(this)).data('index'), 10),  
    touch: true,
    pauseOnHover: true,
    controlNav: "thumbnails",
    directionNav: false,
    before: function(){
                            $('.slides').css('margin-left', '0%');
  },
    
      slideshow: false,
    
    slideshowSpeed: 6*1000
  });

  $('.continue, .mm-opened #header').on("click", function() {
    $('#cart').trigger("close");
    $('#nav').trigger("close");
  });

  $('#search-toggle, .search-close').on('click', function(e) {
    $('.search-close').css('padding-top', $('.header').height() + 100 + 'px')
    if($('#search').is(":visible") && $(window).scrollTop() == 0) {
      $(".index .header").removeClass('header_bar');
      $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
      $(".index .header").addClass('header_bar');
      $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
  })

  $(".search-submit").on('click', function(e) { $(this).parent('form').submit(); });

  $('.lightbox').fancybox();
  
  if ($(window).width() >= 959) {
    $('.thumbnail').hover(function(){ $('.quick_shop', this).show(); }, function(){ $('.quick_shop', this).hide(); })
    var modal_width = '860px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1100px'
    }
    $(".quick_shop").fancybox({
      width: modal_width,
      height: 'auto',
      autoSize: false,
      padding: 0,
      
      beforeShow: function(e) {
        var $gallery = $('#' + $(this.element).data('gallery'));
        var $product = $(this.element).data("fancybox-href");        
        $("img", $gallery).unveil();
        $gallery.flexslider({
          touch: false,
          pauseOnHover: true,
          controlNav: "thumbnails",
          directionNav: false,
          
            slideshow: false,
          
          slideshowSpeed: 6*1000
        });
      },
      afterShow: function() {
      }
    });
  } 

   $('.mm-search input').keypress(function(e) {
    if(e.which == 13) {
        window.location = '/search?q=' + $(this).val();
    }
  });

  $(".fancybox").fancybox({padding: 0, wrapCSS: 'gallery'});

  
  
    

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });  
  
  
    $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });
  
  
  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  $('.toggle').click(function() {
    if ($(window).width() <= 767) { 
      var $toggle = $(this);
      if($toggle.next('ul').is(':visible')) {
        $toggle.removeClass('expanded');
        $toggle.next('ul').hide();
        $toggle.children('span').html('˅');
      } else {
        $toggle.next('ul').show();
        $toggle.addClass('expanded');
        $toggle.children('span').html('˄'); 
      }
    }
  });

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on("submit", function (e) {
      
        $.ajax({
            type: $cf.attr('method'),
            url: $cf.attr('action'),
            data: $cf.serialize(),
            success: function (data) {
              $cf.prev('.message').html($('#general_newsletter_form_success_text').html());
            }
        });
        e.preventDefault();
      
      setTimeout($.fancybox.close, 3000);
    });
  });

  var $notify_form = $('.notify_form .contact-form');
  $notify_form.each(function() {
    var $nf = $(this);
    $nf.on("submit", function (e) {
      if($nf.find('.notify_email').val() != "") {
        $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $notify_form.fadeOut("slow", function(){
                $nf.prev('.message').html($('#products_notify_form_post_success').html());
              });
            }
        });
      } else {
        $nf.prev('.message').html($('#products_notify_form_post_error').html());
      }  
      e.preventDefault();
    });
  });  

  
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    }); 
  

  
//     $(function() {
//       var $target = $("#instafeed");
//       $target.instagramLite({
//         username: $target.data('username'),
//         clientID: $target.data('client-id'),
//         urls: true,
//         videos: true,
//         limit: $target.data('count'),
//         error: function(errorCode, errorMessage) {
//           if(errorCode && errorMessage) {
//             alert(errorCode +': '+ errorMessage);
//           } 
//         }
//         });
//       });
    
  
  var feed = new Instafeed({
      get: 'user',
      userId: 1433583118,
      accessToken: '1433583118.d90570a.f9e8f4f3e99445a597957623fcae0786',
      limit: 6,
      resolution: 'low_resolution',
      
      template: '<div><a href="{{link}}"><img src="{{image}}" /></a></div>',
        
      error: function(message){
        // console.log(message);
      }
    });
    feed.run();


  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/
  function ajaxSubmitCart() {
    $cart = $("#new-cart");
    $.ajax({
      url: '/cart.js',
      dataType: 'json',
      type: 'POST',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function refreshCart(cart) {
    $cartBtn = $(".icon-cart");
    if ($cartBtn) {
      var $cartCount = $cartBtn.find('.cart_count');
      var value = $cartCount.text() || '0';
      var cart_items_html = '';
      var $cart = $("#new-cart ul:first");
      
      if($cartCount && $cartCount.size()) {
        $cartCount.text(value.replace(/[0-9]+/,cart.item_count));
      } else {
        $cartBtn.prepend('<div class="cart_count">' + cart.item_count + '</div>');
      }
      
      $cart.find('li:not(:first)').remove();

      if (cart.item_count == 0) {
        $cart.append('<li class="mm-label empty_cart"><a href="/cart">' + $('#layout_general_empty_cart').html() + '</a></li>');
        $cartCount.remove();
      } else {
        cart_items_html = '<ul class="cart-items-wrapper" style="opacity: 1; width: 100%; max-height: 282px; float: none; display: flex; flex-direction: column; overflow-y: scroll; overflow-x: hidden; background-color: #f2f2f2;">';
        // console.log(cart.items)
        $.each(cart.items, function(index, item) {
          cart_items_html += '<li style="flex-grow: 1; width: 100%; border-bottom: 1px solid rgba(0,0,0,.1);" class="cart_item">' +
            '<a style="padding: 5% 5%;" href="' + item.url +'">';
          if (item.image) {
            cart_items_html += '<div class="cart_image" style="padding-top: 0;" >' +
                '<img src="' + item.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
              '</div>';
          }
          cart_items_html += '<div style="font-weight: normal; white-space: nowrap; padding-top: 10px;" class="item_title">' + item.title +'</div>' +
              '<strong class="price">' + Shopify.formatMoney(item.price, $cart.data('money-format')) + '</strong>' +
              '<div class="quantity_selector">' +
                '<span style="font-size: 200%;" class="minus">-</span><input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" /><span style="font-size: 200%;" class="plus">+</span>' +
              '</div>' +
            '</a>' +
          '</li>';
        });
cart_items_html += '</ul>';
        cart_items_html += '<li style="display: flex; align-items: center; padding: 3%; border-top: 2px solid rgba(0,0,0,.2); border-bottom: 2px solid rgba(0,0,0,.2);" class="mm-label">' + '<div style="flex-grow: 1;"><strong style=" font-size: 150%;">' + $('#layout_general_subtotal').html() + ' </strong>' +
            '<p class="mm-counter">' + Shopify.formatMoney(cart.total_price, $cart.data('money-format')) + '</p></div>' +
          '<a style="flex-grow: 3; display: inline-block; background-color: #f17e21; color: white !important; padding: 3%; text-align: center;" href="/cart" class="action_button">VIEW CART</a></li>' +
          '';

        $cart.html(cart_items_html);


        
      }
    }
  }

  $(document).on("change", "#new-cart input.quantity", function() { 
    ajaxSubmitCart();
  });

  $(document).on("click", ".quantity", function(e) { 
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
  $(document).on("click", ".minus", function(e) { 
    var quantity = parseInt($(this).next("input").val()); 
    quantity -= 1;
    $(this).next("input").attr("value", quantity);
    if (quantity == 0) {
      $(this).closest('li.cart_item').slideUp();
      setTimeout(ajaxSubmitCart, 500);
    } else {
      ajaxSubmitCart();
    }
    e.stopPropagation();
    e.preventDefault();
    return false;
  });
  $(document).on("click", ".plus", function(e) { 
    var quantity = parseInt($(this).prev("input").val()); 
    quantity += 1;
    $(this).prev("input").attr("value", quantity);
    ajaxSubmitCart();
    e.stopPropagation();
    e.preventDefault();
    return false;
  });

  
    if ($('body').attr('id') !== 'cart') {
      $(".product_form, .product-form, .product-subscription-form").submit(function(e) {
        e.preventDefault();
        var $addToCartForm = $(this);  
        var $addToCartBtn = $addToCartForm.find('.add_to_cart');
        
        var quantity = $addToCartForm.find('input[name=quantity]').val();

        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function() {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
          },
          success: function(itemData) {
            // console.log(itemData);
            var imageUrl = itemData.image;
            var html = '<div class="media">' +
                      '<div class="media-left">' +
                      '<a href="#"><img class="media-object" src="' + itemData.image + '" alt="..."></a>' +
                      '</div>' +
                      '<div class="media-body">' +
                      '<h5 class="media-heading">' + (quantity || 1) + ' item(s) added to your cart</h5>' +
                      '<p>' + itemData.title + '</p>' +
                      '</div>' +
                      '</div>';

            var n = new Noty({
              text: html,
              buttons: [
                Noty.button('View cart', 'btn btn-success', function () {
                  window.location.href = '/cart';
                }, {id: 'button1', 'data-status': 'ok'}),

                
              ],
              timeout: 3000,
              closeWith: ['button'],
              progressBar: false
            }).show();
            
            $addToCartBtn.find('span').text($('#products_product_add_to_cart_success').html()).removeClass('zoomOut').addClass('fadeIn');

            window.setTimeout(function(){
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
            }, 2000);

            $.getJSON("/cart.js", function(cart) {
              refreshCart(cart);
              tempCartHover();
              window.setTimeout(function(){ 
                $.fancybox.close(); 
              API.open();
              }, 500);
            });    
          },
          error: function(XMLHttpRequest) {
            var response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;
            $('.warning').remove();

            var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
            $addToCartBtn.before(warning);
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').text($('#products_product_add_to_cart').html()).removeClass('zoomOut').addClass('zoomIn');
          }
        });

        return false;
      });
    }
  

  selectCallback = function(variant, selector) {
    var $product = $('.product-' + selector.product.id);
    var $productDescription = $('#product-description');
    var $notify_form = $('.notify-form-' + selector.product.id);
    var $productForm = $('form.product_form', $product);

    $productDescription.find('div.product-summary').each(function (i, el) {
      if ($(el).attr('data-variant-id') == variant.id) {
        $(el).show();
      } else {
        $(el).hide();
      }
    })
    
    if (variant && variant.featured_image && $product.is(":visible")) {
      var $slider = $('.product_gallery', $product);
      var original_image = $(".flex-active-slide img", $product), new_image = variant.featured_image;
      Shopify.Image.switchImage(new_image, original_image[0], function (new_image_src, original_image, element) {
        $slider.each(function() { $(this).flexslider($('[data-image-id="' + variant.featured_image.id + '"]').data('index')); });
      });
    }

    if (variant) {
      $('.sku span', $product).text(variant.sku);
      $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

      
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + escape(variant.options[i]) +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      
    }

    if (variant) {
      // console.log($('.was_price', $product))
      
      if(variant.price < variant.compare_at_price){
        
        $('.was_price', $product).html(Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')))        
      } else {
        $('.was_price', $product).text('')
      } 

      

      $('.sold_out', $product).text('');
      $('.current_price', $product).html(Shopify.formatMoney(variant.price, $productForm.data('money-format')));
      $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
      $notify_form.hide();
    } else {
      var message = variant ? "Sold Out" : "Unavailable";
      $('.was_price', $product).text('');
      $('.current_price', $product).text('');
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
      $('.sold_out', $product).text(message);
      $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message); 
      $notify_form.fadeIn();


    }
      
//     if (variant) {
//       document.querySelector('.product-savings').innerText = Shopify.formatMoney(variant.price * 0.2);
//     }
    
    

  };          
});

function htmlEncode(value){ 
    if (value) {
        return $('<div/>').text(value).html(); 
    } else {
        return '';
    }
}

/*! fancyBox v2.1.5 fancyapps.com | fancyapps.com/fancybox/#license */
(function(r,G,f,v){var J=f("html"),n=f(r),p=f(G),b=f.fancybox=function(){b.open.apply(this,arguments)},I=navigator.userAgent.match(/msie/i),B=null,s=G.createTouch!==v,t=function(a){return a&&a.hasOwnProperty&&a instanceof f},q=function(a){return a&&"string"===f.type(a)},E=function(a){return q(a)&&0<a.indexOf("%")},l=function(a,d){var e=parseInt(a,10)||0;d&&E(a)&&(e*=b.getViewport()[d]/100);return Math.ceil(e)},w=function(a,b){return l(a,b)+"px"};f.extend(b,{version:"2.1.5",defaults:{padding:15,margin:20,
width:800,height:600,minWidth:100,minHeight:100,maxWidth:9999,maxHeight:9999,pixelRatio:1,autoSize:!0,autoHeight:!1,autoWidth:!1,autoResize:!0,autoCenter:!s,fitToView:!0,aspectRatio:!1,topRatio:0.5,leftRatio:0.5,scrolling:"auto",wrapCSS:"",arrows:!0,closeBtn:!0,closeClick:!1,nextClick:!1,mouseWheel:!0,autoPlay:!1,playSpeed:3E3,preload:3,modal:!1,loop:!0,ajax:{dataType:"html",headers:{"X-fancyBox":!0}},iframe:{scrolling:"auto",preload:!0},swf:{wmode:"transparent",allowfullscreen:"true",allowscriptaccess:"always"},
keys:{next:{13:"left",34:"up",39:"left",40:"up"},prev:{8:"right",33:"down",37:"right",38:"down"},close:[27],play:[32],toggle:[70]},direction:{next:"left",prev:"right"},scrollOutside:!0,index:0,type:null,href:null,content:null,title:null,tpl:{wrap:'<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',image:'<img class="fancybox-image" src="{href}" alt="" />',iframe:'<iframe id="fancybox-frame{rnd}" name="fancybox-fram requested cone{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen'+
(I?' allowtransparency="true"':"")+"></iframe>",error:'<p class="fancybox-error">Thetent cannot be loaded.<br/>Please try again later.</p>',closeBtn:'<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',next:'<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',prev:'<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>'},openEffect:"fade",openSpeed:250,openEasing:"swing",openOpacity:!0,
openMethod:"zoomIn",closeEffect:"fade",closeSpeed:250,closeEasing:"swing",closeOpacity:!0,closeMethod:"zoomOut",nextEffect:"elastic",nextSpeed:250,nextEasing:"swing",nextMethod:"changeIn",prevEffect:"elastic",prevSpeed:250,prevEasing:"swing",prevMethod:"changeOut",helpers:{overlay:!0,title:!0},onCancel:f.noop,beforeLoad:f.noop,afterLoad:f.noop,beforeShow:f.noop,afterShow:f.noop,beforeChange:f.noop,beforeClose:f.noop,afterClose:f.noop},group:{},opts:{},previous:null,coming:null,current:null,isActive:!1,
isOpen:!1,isOpened:!1,wrap:null,skin:null,outer:null,inner:null,player:{timer:null,isActive:!1},ajaxLoad:null,imgPreload:null,transitions:{},helpers:{},open:function(a,d){if(a&&(f.isPlainObject(d)||(d={}),!1!==b.close(!0)))return f.isArray(a)||(a=t(a)?f(a).get():[a]),f.each(a,function(e,c){var k={},g,h,j,m,l;"object"===f.type(c)&&(c.nodeType&&(c=f(c)),t(c)?(k={href:c.data("fancybox-href")||c.attr("href"),title:c.data("fancybox-title")||c.attr("title"),isDom:!0,element:c},f.metadata&&f.extend(!0,k,
c.metadata())):k=c);g=d.href||k.href||(q(c)?c:null);h=d.title!==v?d.title:k.title||"";m=(j=d.content||k.content)?"html":d.type||k.type;!m&&k.isDom&&(m=c.data("fancybox-type"),m||(m=(m=c.prop("class").match(/fancybox\.(\w+)/))?m[1]:null));q(g)&&(m||(b.isImage(g)?m="image":b.isSWF(g)?m="swf":"#"===g.charAt(0)?m="inline":q(c)&&(m="html",j=c)),"ajax"===m&&(l=g.split(/\s+/,2),g=l.shift(),l=l.shift()));j||("inline"===m?g?j=f(q(g)?g.replace(/.*(?=#[^\s]+$)/,""):g):k.isDom&&(j=c):"html"===m?j=g:!m&&(!g&&
k.isDom)&&(m="inline",j=c));f.extend(k,{href:g,type:m,content:j,title:h,selector:l});a[e]=k}),b.opts=f.extend(!0,{},b.defaults,d),d.keys!==v&&(b.opts.keys=d.keys?f.extend({},b.defaults.keys,d.keys):!1),b.group=a,b._start(b.opts.index)},cancel:function(){var a=b.coming;a&&!1!==b.trigger("onCancel")&&(b.hideLoading(),b.ajaxLoad&&b.ajaxLoad.abort(),b.ajaxLoad=null,b.imgPreload&&(b.imgPreload.onload=b.imgPreload.onerror=null),a.wrap&&a.wrap.stop(!0,!0).trigger("onReset").remove(),b.coming=null,b.current||
b._afterZoomOut(a))},close:function(a){b.cancel();!1!==b.trigger("beforeClose")&&(b.unbindEvents(),b.isActive&&(!b.isOpen||!0===a?(f(".fancybox-wrap").stop(!0).trigger("onReset").remove(),b._afterZoomOut()):(b.isOpen=b.isOpened=!1,b.isClosing=!0,f(".fancybox-item, .fancybox-nav").remove(),b.wrap.stop(!0,!0).removeClass("fancybox-opened"),b.transitions[b.current.closeMethod]())))},play:function(a){var d=function(){clearTimeout(b.player.timer)},e=function(){d();b.current&&b.player.isActive&&(b.player.timer=
setTimeout(b.next,b.current.playSpeed))},c=function(){d();p.unbind(".player");b.player.isActive=!1;b.trigger("onPlayEnd")};if(!0===a||!b.player.isActive&&!1!==a){if(b.current&&(b.current.loop||b.current.index<b.group.length-1))b.player.isActive=!0,p.bind({"onCancel.player beforeClose.player":c,"onUpdate.player":e,"beforeLoad.player":d}),e(),b.trigger("onPlayStart")}else c()},next:function(a){var d=b.current;d&&(q(a)||(a=d.direction.next),b.jumpto(d.index+1,a,"next"))},prev:function(a){var d=b.current;
d&&(q(a)||(a=d.direction.prev),b.jumpto(d.index-1,a,"prev"))},jumpto:function(a,d,e){var c=b.current;c&&(a=l(a),b.direction=d||c.direction[a>=c.index?"next":"prev"],b.router=e||"jumpto",c.loop&&(0>a&&(a=c.group.length+a%c.group.length),a%=c.group.length),c.group[a]!==v&&(b.cancel(),b._start(a)))},reposition:function(a,d){var e=b.current,c=e?e.wrap:null,k;c&&(k=b._getPosition(d),a&&"scroll"===a.type?(delete k.position,c.stop(!0,!0).animate(k,200)):(c.css(k),e.pos=f.extend({},e.dim,k)))},update:function(a){var d=
a&&a.type,e=!d||"orientationchange"===d;e&&(clearTimeout(B),B=null);b.isOpen&&!B&&(B=setTimeout(function(){var c=b.current;c&&!b.isClosing&&(b.wrap.removeClass("fancybox-tmp"),(e||"load"===d||"resize"===d&&c.autoResize)&&b._setDimension(),"scroll"===d&&c.canShrink||b.reposition(a),b.trigger("onUpdate"),B=null)},e&&!s?0:300))},toggle:function(a){b.isOpen&&(b.current.fitToView="boolean"===f.type(a)?a:!b.current.fitToView,s&&(b.wrap.removeAttr("style").addClass("fancybox-tmp"),b.trigger("onUpdate")),
b.update())},hideLoading:function(){p.unbind(".loading");f("#fancybox-loading").remove()},showLoading:function(){var a,d;b.hideLoading();a=f('<div id="fancybox-loading"><div></div></div>').click(b.cancel).appendTo("body");p.bind("keydown.loading",function(a){if(27===(a.which||a.keyCode))a.preventDefault(),b.cancel()});b.defaults.fixed||(d=b.getViewport(),a.css({position:"absolute",top:0.5*d.h+d.y,left:0.5*d.w+d.x}))},getViewport:function(){var a=b.current&&b.current.locked||!1,d={x:n.scrollLeft(),
y:n.scrollTop()};a?(d.w=a[0].clientWidth,d.h=a[0].clientHeight):(d.w=s&&r.innerWidth?r.innerWidth:n.width(),d.h=s&&r.innerHeight?r.innerHeight:n.height());return d},unbindEvents:function(){b.wrap&&t(b.wrap)&&b.wrap.unbind(".fb");p.unbind(".fb");n.unbind(".fb")},bindEvents:function(){var a=b.current,d;a&&(n.bind("orientationchange.fb"+(s?"":" resize.fb")+(a.autoCenter&&!a.locked?" scroll.fb":""),b.update),(d=a.keys)&&p.bind("keydown.fb",function(e){var c=e.which||e.keyCode,k=e.target||e.srcElement;
if(27===c&&b.coming)return!1;!e.ctrlKey&&(!e.altKey&&!e.shiftKey&&!e.metaKey&&(!k||!k.type&&!f(k).is("[contenteditable]")))&&f.each(d,function(d,k){if(1<a.group.length&&k[c]!==v)return b[d](k[c]),e.preventDefault(),!1;if(-1<f.inArray(c,k))return b[d](),e.preventDefault(),!1})}),f.fn.mousewheel&&a.mouseWheel&&b.wrap.bind("mousewheel.fb",function(d,c,k,g){for(var h=f(d.target||null),j=!1;h.length&&!j&&!h.is(".fancybox-skin")&&!h.is(".fancybox-wrap");)j=h[0]&&!(h[0].style.overflow&&"hidden"===h[0].style.overflow)&&
(h[0].clientWidth&&h[0].scrollWidth>h[0].clientWidth||h[0].clientHeight&&h[0].scrollHeight>h[0].clientHeight),h=f(h).parent();if(0!==c&&!j&&1<b.group.length&&!a.canShrink){if(0<g||0<k)b.prev(0<g?"down":"left");else if(0>g||0>k)b.next(0>g?"up":"right");d.preventDefault()}}))},trigger:function(a,d){var e,c=d||b.coming||b.current;if(c){f.isFunction(c[a])&&(e=c[a].apply(c,Array.prototype.slice.call(arguments,1)));if(!1===e)return!1;c.helpers&&f.each(c.helpers,function(d,e){if(e&&b.helpers[d]&&f.isFunction(b.helpers[d][a]))b.helpers[d][a](f.extend(!0,
{},b.helpers[d].defaults,e),c)});p.trigger(a)}},isImage:function(a){return q(a)&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)},isSWF:function(a){return q(a)&&a.match(/\.(swf)((\?|#).*)?$/i)},_start:function(a){var d={},e,c;a=l(a);e=b.group[a]||null;if(!e)return!1;d=f.extend(!0,{},b.opts,e);e=d.margin;c=d.padding;"number"===f.type(e)&&(d.margin=[e,e,e,e]);"number"===f.type(c)&&(d.padding=[c,c,c,c]);d.modal&&f.extend(!0,d,{closeBtn:!1,closeClick:!1,nextClick:!1,arrows:!1,
mouseWheel:!1,keys:null,helpers:{overlay:{closeClick:!1}}});d.autoSize&&(d.autoWidth=d.autoHeight=!0);"auto"===d.width&&(d.autoWidth=!0);"auto"===d.height&&(d.autoHeight=!0);d.group=b.group;d.index=a;b.coming=d;if(!1===b.trigger("beforeLoad"))b.coming=null;else{c=d.type;e=d.href;if(!c)return b.coming=null,b.current&&b.router&&"jumpto"!==b.router?(b.current.index=a,b[b.router](b.direction)):!1;b.isActive=!0;if("image"===c||"swf"===c)d.autoHeight=d.autoWidth=!1,d.scrolling="visible";"image"===c&&(d.aspectRatio=
!0);"iframe"===c&&s&&(d.scrolling="scroll");d.wrap=f(d.tpl.wrap).addClass("fancybox-"+(s?"mobile":"desktop")+" fancybox-type-"+c+" fancybox-tmp "+d.wrapCSS).appendTo(d.parent||"body");f.extend(d,{skin:f(".fancybox-skin",d.wrap),outer:f(".fancybox-outer",d.wrap),inner:f(".fancybox-inner",d.wrap)});f.each(["Top","Right","Bottom","Left"],function(a,b){d.skin.css("padding"+b,w(d.padding[a]))});b.trigger("onReady");if("inline"===c||"html"===c){if(!d.content||!d.content.length)return b._error("content")}else if(!e)return b._error("href");
"image"===c?b._loadImage():"ajax"===c?b._loadAjax():"iframe"===c?b._loadIframe():b._afterLoad()}},_error:function(a){f.extend(b.coming,{type:"html",autoWidth:!0,autoHeight:!0,minWidth:0,minHeight:0,scrolling:"no",hasError:a,content:b.coming.tpl.error});b._afterLoad()},_loadImage:function(){var a=b.imgPreload=new Image;a.onload=function(){this.onload=this.onerror=null;b.coming.width=this.width/b.opts.pixelRatio;b.coming.height=this.height/b.opts.pixelRatio;b._afterLoad()};a.onerror=function(){this.onload=
this.onerror=null;b._error("image")};a.src=b.coming.href;!0!==a.complete&&b.showLoading()},_loadAjax:function(){var a=b.coming;b.showLoading();b.ajaxLoad=f.ajax(f.extend({},a.ajax,{url:a.href,error:function(a,e){b.coming&&"abort"!==e?b._error("ajax",a):b.hideLoading()},success:function(d,e){"success"===e&&(a.content=d,b._afterLoad())}}))},_loadIframe:function(){var a=b.coming,d=f(a.tpl.iframe.replace(/\{rnd\}/g,(new Date).getTime())).attr("scrolling",s?"auto":a.iframe.scrolling).attr("src",a.href);
f(a.wrap).bind("onReset",function(){try{f(this).find("iframe").hide().attr("src","//about:blank").end().empty()}catch(a){}});a.iframe.preload&&(b.showLoading(),d.one("load",function(){f(this).data("ready",1);s||f(this).bind("load.fb",b.update);f(this).parents(".fancybox-wrap").width("100%").removeClass("fancybox-tmp").show();b._afterLoad()}));a.content=d.appendTo(a.inner);a.iframe.preload||b._afterLoad()},_preloadImages:function(){var a=b.group,d=b.current,e=a.length,c=d.preload?Math.min(d.preload,
e-1):0,f,g;for(g=1;g<=c;g+=1)f=a[(d.index+g)%e],"image"===f.type&&f.href&&((new Image).src=f.href)},_afterLoad:function(){var a=b.coming,d=b.current,e,c,k,g,h;b.hideLoading();if(a&&!1!==b.isActive)if(!1===b.trigger("afterLoad",a,d))a.wrap.stop(!0).trigger("onReset").remove(),b.coming=null;else{d&&(b.trigger("beforeChange",d),d.wrap.stop(!0).removeClass("fancybox-opened").find(".fancybox-item, .fancybox-nav").remove());b.unbindEvents();e=a.content;c=a.type;k=a.scrolling;f.extend(b,{wrap:a.wrap,skin:a.skin,
outer:a.outer,inner:a.inner,current:a,previous:d});g=a.href;switch(c){case "inline":case "ajax":case "html":a.selector?e=f("<div>").html(e).find(a.selector):t(e)&&(e.data("fancybox-placeholder")||e.data("fancybox-placeholder",f('<div class="fancybox-placeholder"></div>').insertAfter(e).hide()),e=e.show().detach(),a.wrap.bind("onReset",function(){f(this).find(e).length&&e.hide().replaceAll(e.data("fancybox-placeholder")).data("fancybox-placeholder",!1)}));break;case "image":e=a.tpl.image.replace("{href}",
g);break;case "swf":e='<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="'+g+'"></param>',h="",f.each(a.swf,function(a,b){e+='<param name="'+a+'" value="'+b+'"></param>';h+=" "+a+'="'+b+'"'}),e+='<embed src="'+g+'" type="application/x-shockwave-flash" width="100%" height="100%"'+h+"></embed></object>"}(!t(e)||!e.parent().is(a.inner))&&a.inner.append(e);b.trigger("beforeShow");a.inner.css("overflow","yes"===k?"scroll":
"no"===k?"hidden":k);b._setDimension();b.reposition();b.isOpen=!1;b.coming=null;b.bindEvents();if(b.isOpened){if(d.prevMethod)b.transitions[d.prevMethod]()}else f(".fancybox-wrap").not(a.wrap).stop(!0).trigger("onReset").remove();b.transitions[b.isOpened?a.nextMethod:a.openMethod]();b._preloadImages()}},_setDimension:function(){var a=b.getViewport(),d=0,e=!1,c=!1,e=b.wrap,k=b.skin,g=b.inner,h=b.current,c=h.width,j=h.height,m=h.minWidth,u=h.minHeight,n=h.maxWidth,p=h.maxHeight,s=h.scrolling,q=h.scrollOutside?
h.scrollbarWidth:0,x=h.margin,y=l(x[1]+x[3]),r=l(x[0]+x[2]),v,z,t,C,A,F,B,D,H;e.add(k).add(g).width("auto").height("auto").removeClass("fancybox-tmp");x=l(k.outerWidth(!0)-k.width());v=l(k.outerHeight(!0)-k.height());z=y+x;t=r+v;C=E(c)?(a.w-z)*l(c)/100:c;A=E(j)?(a.h-t)*l(j)/100:j;if("iframe"===h.type){if(H=h.content,h.autoHeight&&1===H.data("ready"))try{H[0].contentWindow.document.location&&(g.width(C).height(9999),F=H.contents().find("body"),q&&F.css("overflow-x","hidden"),A=F.outerHeight(!0))}catch(G){}}else if(h.autoWidth||
h.autoHeight)g.addClass("fancybox-tmp"),h.autoWidth||g.width(C),h.autoHeight||g.height(A),h.autoWidth&&(C=g.width()),h.autoHeight&&(A=g.height()),g.removeClass("fancybox-tmp");c=l(C);j=l(A);D=C/A;m=l(E(m)?l(m,"w")-z:m);n=l(E(n)?l(n,"w")-z:n);u=l(E(u)?l(u,"h")-t:u);p=l(E(p)?l(p,"h")-t:p);F=n;B=p;h.fitToView&&(n=Math.min(a.w-z,n),p=Math.min(a.h-t,p));z=a.w-y;r=a.h-r;h.aspectRatio?(c>n&&(c=n,j=l(c/D)),j>p&&(j=p,c=l(j*D)),c<m&&(c=m,j=l(c/D)),j<u&&(j=u,c=l(j*D))):(c=Math.max(m,Math.min(c,n)),h.autoHeight&&
"iframe"!==h.type&&(g.width(c),j=g.height()),j=Math.max(u,Math.min(j,p)));if(h.fitToView)if(g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height(),h.aspectRatio)for(;(a>z||y>r)&&(c>m&&j>u)&&!(19<d++);)j=Math.max(u,Math.min(p,j-10)),c=l(j*D),c<m&&(c=m,j=l(c/D)),c>n&&(c=n,j=l(c/D)),g.width(c).height(j),e.width(c+x),a=e.width(),y=e.height();else c=Math.max(m,Math.min(c,c-(a-z))),j=Math.max(u,Math.min(j,j-(y-r)));q&&("auto"===s&&j<A&&c+x+q<z)&&(c+=q);g.width(c).height(j);e.width(c+x);a=e.width();
y=e.height();e=(a>z||y>r)&&c>m&&j>u;c=h.aspectRatio?c<F&&j<B&&c<C&&j<A:(c<F||j<B)&&(c<C||j<A);f.extend(h,{dim:{width:w(a),height:w(y)},origWidth:C,origHeight:A,canShrink:e,canExpand:c,wPadding:x,hPadding:v,wrapSpace:y-k.outerHeight(!0),skinSpace:k.height()-j});!H&&(h.autoHeight&&j>u&&j<p&&!c)&&g.height("auto")},_getPosition:function(a){var d=b.current,e=b.getViewport(),c=d.margin,f=b.wrap.width()+c[1]+c[3],g=b.wrap.height()+c[0]+c[2],c={position:"absolute",top:c[0],left:c[3]};d.autoCenter&&d.fixed&&
!a&&g<=e.h&&f<=e.w?c.position="fixed":d.locked||(c.top+=e.y,c.left+=e.x);c.top=w(Math.max(c.top,c.top+(e.h-g)*d.topRatio));c.left=w(Math.max(c.left,c.left+(e.w-f)*d.leftRatio));return c},_afterZoomIn:function(){var a=b.current;a&&(b.isOpen=b.isOpened=!0,b.wrap.css("overflow","visible").addClass("fancybox-opened"),b.update(),(a.closeClick||a.nextClick&&1<b.group.length)&&b.inner.css("cursor","pointer").bind("click.fb",function(d){!f(d.target).is("a")&&!f(d.target).parent().is("a")&&(d.preventDefault(),
b[a.closeClick?"close":"next"]())}),a.closeBtn&&f(a.tpl.closeBtn).appendTo(b.skin).bind("click.fb",function(a){a.preventDefault();b.close()}),a.arrows&&1<b.group.length&&((a.loop||0<a.index)&&f(a.tpl.prev).appendTo(b.outer).bind("click.fb",b.prev),(a.loop||a.index<b.group.length-1)&&f(a.tpl.next).appendTo(b.outer).bind("click.fb",b.next)),b.trigger("afterShow"),!a.loop&&a.index===a.group.length-1?b.play(!1):b.opts.autoPlay&&!b.player.isActive&&(b.opts.autoPlay=!1,b.play()))},_afterZoomOut:function(a){a=
a||b.current;f(".fancybox-wrap").trigger("onReset").remove();f.extend(b,{group:{},opts:{},router:!1,current:null,isActive:!1,isOpened:!1,isOpen:!1,isClosing:!1,wrap:null,skin:null,outer:null,inner:null});b.trigger("afterClose",a)}});b.transitions={getOrigPosition:function(){var a=b.current,d=a.element,e=a.orig,c={},f=50,g=50,h=a.hPadding,j=a.wPadding,m=b.getViewport();!e&&(a.isDom&&d.is(":visible"))&&(e=d.find("img:first"),e.length||(e=d));t(e)?(c=e.offset(),e.is("img")&&(f=e.outerWidth(),g=e.outerHeight())):
(c.top=m.y+(m.h-g)*a.topRatio,c.left=m.x+(m.w-f)*a.leftRatio);if("fixed"===b.wrap.css("position")||a.locked)c.top-=m.y,c.left-=m.x;return c={top:w(c.top-h*a.topRatio),left:w(c.left-j*a.leftRatio),width:w(f+j),height:w(g+h)}},step:function(a,d){var e,c,f=d.prop;c=b.current;var g=c.wrapSpace,h=c.skinSpace;if("width"===f||"height"===f)e=d.end===d.start?1:(a-d.start)/(d.end-d.start),b.isClosing&&(e=1-e),c="width"===f?c.wPadding:c.hPadding,c=a-c,b.skin[f](l("width"===f?c:c-g*e)),b.inner[f](l("width"===
f?c:c-g*e-h*e))},zoomIn:function(){var a=b.current,d=a.pos,e=a.openEffect,c="elastic"===e,k=f.extend({opacity:1},d);delete k.position;c?(d=this.getOrigPosition(),a.openOpacity&&(d.opacity=0.1)):"fade"===e&&(d.opacity=0.1);b.wrap.css(d).animate(k,{duration:"none"===e?0:a.openSpeed,easing:a.openEasing,step:c?this.step:null,complete:b._afterZoomIn})},zoomOut:function(){var a=b.current,d=a.closeEffect,e="elastic"===d,c={opacity:0.1};e&&(c=this.getOrigPosition(),a.closeOpacity&&(c.opacity=0.1));b.wrap.animate(c,
{duration:"none"===d?0:a.closeSpeed,easing:a.closeEasing,step:e?this.step:null,complete:b._afterZoomOut})},changeIn:function(){var a=b.current,d=a.nextEffect,e=a.pos,c={opacity:1},f=b.direction,g;e.opacity=0.1;"elastic"===d&&(g="down"===f||"up"===f?"top":"left","down"===f||"right"===f?(e[g]=w(l(e[g])-200),c[g]="+=200px"):(e[g]=w(l(e[g])+200),c[g]="-=200px"));"none"===d?b._afterZoomIn():b.wrap.css(e).animate(c,{duration:a.nextSpeed,easing:a.nextEasing,complete:b._afterZoomIn})},changeOut:function(){var a=
b.previous,d=a.prevEffect,e={opacity:0.1},c=b.direction;"elastic"===d&&(e["down"===c||"up"===c?"top":"left"]=("up"===c||"left"===c?"-":"+")+"=200px");a.wrap.animate(e,{duration:"none"===d?0:a.prevSpeed,easing:a.prevEasing,complete:function(){f(this).trigger("onReset").remove()}})}};b.helpers.overlay={defaults:{closeClick:!0,speedOut:200,showEarly:!0,css:{},locked:!s,fixed:!0},overlay:null,fixed:!1,el:f("html"),create:function(a){a=f.extend({},this.defaults,a);this.overlay&&this.close();this.overlay=
f('<div class="fancybox-overlay"></div>').appendTo(b.coming?b.coming.parent:a.parent);this.fixed=!1;a.fixed&&b.defaults.fixed&&(this.overlay.addClass("fancybox-overlay-fixed"),this.fixed=!0)},open:function(a){var d=this;a=f.extend({},this.defaults,a);this.overlay?this.overlay.unbind(".overlay").width("auto").height("auto"):this.create(a);this.fixed||(n.bind("resize.overlay",f.proxy(this.update,this)),this.update());a.closeClick&&this.overlay.bind("click.overlay",function(a){if(f(a.target).hasClass("fancybox-overlay"))return b.isActive?
b.close():d.close(),!1});this.overlay.css(a.css).show()},close:function(){var a,b;n.unbind("resize.overlay");this.el.hasClass("fancybox-lock")&&(f(".fancybox-margin").removeClass("fancybox-margin"),a=n.scrollTop(),b=n.scrollLeft(),this.el.removeClass("fancybox-lock"),n.scrollTop(a).scrollLeft(b));f(".fancybox-overlay").remove().hide();f.extend(this,{overlay:null,fixed:!1})},update:function(){var a="100%",b;this.overlay.width(a).height("100%");I?(b=Math.max(G.documentElement.offsetWidth,G.body.offsetWidth),
p.width()>b&&(a=p.width())):p.width()>n.width()&&(a=p.width());this.overlay.width(a).height(p.height())},onReady:function(a,b){var e=this.overlay;f(".fancybox-overlay").stop(!0,!0);e||this.create(a);a.locked&&(this.fixed&&b.fixed)&&(e||(this.margin=p.height()>n.height()?f("html").css("margin-right").replace("px",""):!1),b.locked=this.overlay.append(b.wrap),b.fixed=!1);!0===a.showEarly&&this.beforeShow.apply(this,arguments)},beforeShow:function(a,b){var e,c;b.locked&&(!1!==this.margin&&(f("*").filter(function(){return"fixed"===
f(this).css("position")&&!f(this).hasClass("fancybox-overlay")&&!f(this).hasClass("fancybox-wrap")}).addClass("fancybox-margin"),this.el.addClass("fancybox-margin")),e=n.scrollTop(),c=n.scrollLeft(),this.el.addClass("fancybox-lock"),n.scrollTop(e).scrollLeft(c));this.open(a)},onUpdate:function(){this.fixed||this.update()},afterClose:function(a){this.overlay&&!b.coming&&this.overlay.fadeOut(a.speedOut,f.proxy(this.close,this))}};b.helpers.title={defaults:{type:"float",position:"bottom"},beforeShow:function(a){var d=
b.current,e=d.title,c=a.type;f.isFunction(e)&&(e=e.call(d.element,d));if(q(e)&&""!==f.trim(e)){d=f('<div class="fancybox-title fancybox-title-'+c+'-wrap">'+e+"</div>");switch(c){case "inside":c=b.skin;break;case "outside":c=b.wrap;break;case "over":c=b.inner;break;default:c=b.skin,d.appendTo("body"),I&&d.width(d.width()),d.wrapInner('<span class="child"></span>'),b.current.margin[2]+=Math.abs(l(d.css("margin-bottom")))}d["top"===a.position?"prependTo":"appendTo"](c)}}};f.fn.fancybox=function(a){var d,
e=f(this),c=this.selector||"",k=function(g){var h=f(this).blur(),j=d,k,l;!g.ctrlKey&&(!g.altKey&&!g.shiftKey&&!g.metaKey)&&!h.is(".fancybox-wrap")&&(k=a.groupAttr||"data-fancybox-group",l=h.attr(k),l||(k="rel",l=h.get(0)[k]),l&&(""!==l&&"nofollow"!==l)&&(h=c.length?f(c):e,h=h.filter("["+k+'="'+l+'"]'),j=h.index(this)),a.index=j,!1!==b.open(h,a)&&g.preventDefault())};a=a||{};d=a.index||0;!c||!1===a.live?e.unbind("click.fb-start").bind("click.fb-start",k):p.undelegate(c,"click.fb-start").delegate(c+
":not('.fancybox-item, .fancybox-nav')","click.fb-start",k);this.filter("[data-fancybox-start=1]").trigger("click");return this};p.ready(function(){var a,d;f.scrollbarWidth===v&&(f.scrollbarWidth=function(){var a=f('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),b=a.children(),b=b.innerWidth()-b.height(99).innerWidth();a.remove();return b});if(f.support.fixedPosition===v){a=f.support;d=f('<div style="position:fixed;top:20px;"></div>').appendTo("body");var e=20===
d[0].offsetTop||15===d[0].offsetTop;d.remove();a.fixedPosition=e}f.extend(b.defaults,{scrollbarWidth:f.scrollbarWidth(),fixed:f.support.fixedPosition,parent:f("body")});a=f(r).width();J.addClass("fancybox-lock-test");d=f(r).width();J.removeClass("fancybox-lock-test");f("<style type='text/css'>.fancybox-margin{margin-right:"+(d-a)+"px;}</style>").appendTo("head")})})(window,document,jQuery);



/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($){$.fn.unveil=function(threshold,callback){var $w=$(window),th=threshold||0,retina=window.devicePixelRatio>1,attrib=retina?"data-src-retina":"data-src",images=this,loaded;this.one("unveil",function(){var source=this.getAttribute(attrib);source=source||this.getAttribute("data-src");if(source){this.setAttribute("src",source);if(typeof callback==="function")callback.call(this);}});function unveil(){var inview=images.filter(function(){var $e=$(this),wt=$w.scrollTop(),wb=wt+$w.height(),et=$e.offset().top,eb=et+$e.height();return eb>=wt-th&&et<=wb+th;});loaded=inview.trigger("unveil");images=images.not(loaded);}$w.scroll(unveil);$w.resize(unveil);unveil();return this;};})(window.jQuery||window.Zepto);

/*!
* Improved jQuery.cookie plugin – http://mths.be/abf
* 
* Based on
*  - the original MIT/GPL-licensed jQuery cookie plugin by Klaus Hartl (stilbuero.de)
*  - readCookie() by Lea Verou, James Padolsey and Juriy Zaytsev: http://mths.be/abe
*/

/*
* This plugin intentionally uses the same syntax as the original jQuery cookie plugin, for backwards compatibility.
*
* Examples:
* =========
*
* Create a cookie with the given name and value and other optional parameters.
*
* @example $.cookie('the_cookie', 'the_value');
* @desc Set the value of a cookie.
* @example $.cookie('the_cookie', 'the_value', { expires: 7, path: '/', domain: 'jquery.com', secure: true });
* @desc Create a cookie with all available options.
* @example $.cookie('the_cookie', 'the_value');
* @desc Create a session cookie.
* @example $.cookie('the_cookie', null);
* @desc Delete a cookie by passing null as value. Keep in mind that you have to use the same path and domain used when the cookie was set.
*
* @param String name The name of the cookie.
* @param String value The value of the cookie.
* @param Object options An object literal containing key/value pairs to provide optional cookie attributes.
* @option Number|Date expires Either an integer specifying the expiration date from now on in days or a Date object.
*                             If a negative value is specified (e.g. a date in the past), the cookie will be deleted.
*                             If set to null or omitted, the cookie will be a session cookie and will not be retained when the the browser exits.
* @option String path The value of the path atribute of the cookie (default: path of page that created the cookie).
* @option String domain The value of the domain attribute of the cookie (default: domain of page that created the cookie).
* @option Boolean secure If true, the secure attribute of the cookie will be set and the cookie transmission will require a secure protocol (like HTTPS).
* @type undefined
*
* Get the value of a cookie with the given name.
*
* @example $.cookie('the_cookie');
* @desc Get the value of a cookie.
*
* @param String name The name of the cookie.
* @return The value of the cookie.
* @type String
*/

;(function(document, $) {
	$.cookie = function(name, value, options) {
		var expires = '',
		    date,
		    match;
		if (typeof value != 'undefined') { // name and value given, set cookie
			options || (options = {});
			if (!value) {
				value = '';
				options.expires = -1;
			}
			if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
				date = new Date;
				if (typeof options.expires == 'number') {
					date.setTime(+new Date() + (options.expires * 864e5)); // 86,400,000 ms = 1 day
				} else {
					date = options.expires;
				}
				expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
			}
			document.cookie = [
				name,
				'=',
				encodeURIComponent(value),
				expires,
				options.path ? '; path=' + options.path : '',
				options.domain ? '; domain=' + options.domain : '', 
				options.secure ? '; secure' : ''
			].join('');
		} else { // only name given, get cookie
			match = document.cookie.match(new RegExp('(?:^|;)\\s?' + name.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1') + '=(.*?)(?:;|$)', 'i'));
			return match && unescape(match[1]);
		};
	};
}(document, jQuery));


/*!

Name: Instagram Lite
Dependencies: jQuery
Author: Michael Lynch
Author URL: http://michaelynch.com
Date Created: January 14, 2014
Licensed under the MIT license

*/




;(function($) {

    $.fn.instagramLite = function(options) {
    
      // return if no element was bound
    // so chained events can continue
    if(!this.length) { 
      return this; 
    }

    // define default parameters
        var defaults = {
            username: null,
            clientID: null,
            limit: null,
            list: true,
            videos: false,
            urls: false,
            captions: false,
            date: false,
            likes: false,
            max_id: null,
            loadMore: null,
            error: function() {},
            success: function() {}
        }
        
        // define plugin
        self.plugin = this;

        // define settings
        self.plugin.settings = {}
 
        // merge defaults and options
        self.plugin.settings = $.extend({}, defaults, options);

        // define element
        self.el = $(this);
       
        // init
        self.loadContent();
        
        // bind load more click event
        if(plugin.settings.loadMore){
          $(plugin.settings.loadMore).on('click',function(e){
            e.preventDefault();
            self.loadContent();
          });
        } 
    },
    
    getMaxId = function(items){
    
      // return id of last item
      return items[items.length-1].id;
    },
    
    formatCaption = function(caption) {
    
      var words = caption.split(' '),
        newCaption = '';
      
      for(var i = 0; i < words.length; i++) {        
        var word;
        
        if(words[i][0] == '@') {
          var a = '<a href="http://twitter.com/'+words[i].replace('@', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else if(words[i][0] == '#') {
          var a = '<a href="http://twitter.com/hashtag/'+words[i].replace('#', '').toLowerCase()+'" target="_blank">'+words[i]+'</a>';
          word = a;
        } else {
          word = words[i]
        }

        newCaption += word + ' ';
        
      }
    
      return newCaption;
      
    },
    
    loadContent = function(){

      // if client ID and username were provided
        if(plugin.settings.clientID && plugin.settings.username) {
        
          // for each element
          el.each(function() {
          
            // search the user
            // to get user ID
            $.ajax({
              type: 'GET',
              url: 'https://api.instagram.com/v1/users/search?q='+plugin.settings.username+'&client_id='+plugin.settings.clientID+'&callback=?',
              dataType: 'jsonp',
              success: function(data) {
  
                if(data.data.length) {
              
                  // for each user returned
                  for(var i = 0; i < data.data.length; i++) {
                  
                    //d efine user namespace
                    var thisUser = data.data[i];
                    
                    // if returned username matches supplied username
                    if(thisUser.username === plugin.settings.username) {
                    
                      // construct API endpoint
                  var url = 'https://api.instagram.com/v1/users/'+thisUser.id+'/media/recent/?client_id='+plugin.settings.clientID+'&count='+plugin.settings.limit+'&callback=?';
                  
                  // concat max id if max id is set
                  url += (plugin.settings.max_id) ? '&max_id='+plugin.settings.max_id : '';
  
                      $.ajax({
                        type: 'GET',
                        url: url,
                        dataType: 'jsonp',
                        success: function(data) {
                          
                          // if success status
                          if(data.meta.code === 200 && data.data.length) {
                        
                            // for each piece of media returned
                            for(var i = 0; i < data.data.length; i++) {
                            
                              // define media namespace
                              var thisMedia = data.data[i],
                                item;
                              
                              // if media type is image
                              if(thisMedia.type === 'image') {
                              
                                // construct image
                                item = '<img class="il-photo__img" src="'+thisMedia.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+thisMedia.filter+'" />';
  
                                // if url setting is true
                                if(plugin.settings.urls) {
                                
                                  item = '<a href="'+thisMedia.link+'" target="_blank">'+item+'</a>';
                                  
                                }
                                
                                if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                                  item += '<div class="il-photo__meta">';
                                }
                                
                                // if caption setting is true
                                if(plugin.settings.captions && thisMedia.caption) {
                                
                                  item += '<div class="il-photo__caption" data-caption-id="'+thisMedia.caption.id+'">'+self.formatCaption(thisMedia.caption.text)+'</div>';
                                  
                                }
                                
                                // if date setting is true
                                if(plugin.settings.date) {
                                
                                  var date = new Date(thisMedia.created_time * 1000),
                                    day = date.getDate(),
                                month = date.getMonth() + 1,
                                year = date.getFullYear(),
                                hours = date.getHours(),
                                minutes = date.getMinutes(),
                                seconds = date.getSeconds();
                                
                              date = month +'/'+ day +'/'+ year;
                                
                                  item += '<div class="il-photo__date">'+date+'</div>';
                                  
                                }
                                
                                // if likes setting is true
                                if(plugin.settings.likes) {
                                
                                  item += '<div class="il-photo__likes">'+thisMedia.likes.count+'</div>';
                                  
                                }
                                
                                if(plugin.settings.captions || plugin.settings.date || plugin.settings.likes) {
                                  item += '</div>';
                                }

                              }
                              
                              if(thisMedia.type === 'video' && plugin.settings.videos) {
                                
                                if(thisMedia.videos) {
                                
                                  var src;
                                
                                  if(thisMedia.videos.standard_resolution) {
                                  
                                    src = thisMedia.videos.standard_resolution.url;
                                    
                                  } else if(thisMedia.videos.low_resolution) {
                                  
                                    src = thisMedia.videos.low_resolution.url;
                                    
                                  } else if(thisMedia.videos.low_bandwidth) {
                                  
                                    src = thisMedia.videos.low_bandwidth.url;
                                    
                                  }
                                  
                                  item = '<video poster="'+thisMedia.images.standard_resolution.url+'" controls>';
                                  
                                  item += '<source src="'+src+'" type="video/mp4;"></source>';
                                  
                                  item += '</video>';
                                  
                                }
                              }
                              
                              // if list setting is true
                              if(plugin.settings.list) {
                                var item="<div class=\"one-fifth column\">"+item+"</div>";
                              }

                              // append image
                              el.append(item);
                              
                            }
                            
                            // set new max id
                            plugin.settings.max_id = self.getMaxId(data.data);
                            
                            // execute success callback
                            plugin.settings.success.call(this);
                          
                          } else {
                            
                            // execute error callback
                            plugin.settings.error.call(this, data.meta.code, data.meta.error_message);
                            
                          }
                        
                        },
                        error: function() {
                        
                          // recent media ajax request failed
                          // execute error callback
                          plugin.settings.error.call(this);
                          
                        }
                      });
                    
                      break;
                      
                    }
                    
                  }
                
                } else {
                
                  // error finding username
                  // execute error callback
              plugin.settings.error.call(this);
                  
                }
                
              },
              error: function() {
              
                // search username ajax request failed
                // execute error callback
            plugin.settings.error.call(this);
                
              }
            });
          
          });
        
        } else {
          alert('Both a Client ID and Instagram username are required to display Instagram profile images.');
        }
    }
    
})(jQuery);

jQuery(function(){
 jQuery('ul#mm-0').prepend('<li><a href="http://www.yoursuperfoods.us/">Home</a></li>');
});



  ////
//   COUNTDOWN PLUGIN
////

;(function ($) {

  $.fn.countdown = function(options){
    //global variables 
    var vars = $.extend({}, $.fn.countdown.defaults, options),
        $counter = $(this),
        t = {day: 0, hour: 0, minute: 0, sec: 0},
        targetDate = new Date(vars.targetDate).getTime(),
        secondsLeft;


    //private methods
    methods = {
      setup: function () {
        
        $.each(t, function(time, value){
          var currentSection = '<ul id="'+time+'"><li>0</li><li>0</li></ul>';
          $counter.append(currentSection);
        });
        
        if (vars.labels) {
          var labelHtml = '<div class="labels clearfix"><ul class="clearfix"><li class="days">Days</li><li class="hours">Hours</li><li class="minutes">Minutes</li><li class="seconds">Seconds</li></ul></div>';
          $counter.append(labelHtml);
        }

      },

      updateTime: function(){
        var currentTime = new Date().getTime(),
            secondsLeft = (targetDate - currentTime) / 1000,
            secsIn = {day: 86400, hour: 3600, minute: 60};

        if (secondsLeft < 0) {secondsLeft = 0;}
        
        $.each(t, function(timePeriod, value){
          t[timePeriod] = parseInt( (secondsLeft / secsIn[timePeriod]), 10);
          if (timePeriod !== 'sec'){
           secondsLeft = secondsLeft % secsIn[timePeriod];
          } 
          else {
            t[timePeriod] = secondsLeft;
          }
        });
      },

      updateCounter: function() {
        $.each(t, function(period, value){
          var section = $counter.find('#'+period).children(),
              digit = splitDigits(value);
          
          section.eq(0).html(digit[0]);
          section.eq(1).html(digit[1]);
        });

        function splitDigits(number) {
          var digits = [];
          digits[0] = Math.floor(number / 10);
          digits[1] = Math.floor(number % 10);
          return digits; 
        }
      },

      tick: function () {
        if (secondsLeft < 1) {}
        else {
          methods.updateTime();
          methods.updateCounter();
          setTimeout(function() {methods.tick();}, 1000);
        } 
      },

      init: function () {
        methods.setup();
        methods.updateTime();
        methods.updateCounter();
        methods.tick();
      },
    };

    //initiate countdown
    methods.init();
  };

  $.fn.countdown.defaults = {
    targetDate: 'dec 31 2014',    //string: the date you want the counter to count down to.
    labels:     true              //boolean: toggles the {day / hour / minute / second} labels 
  };
}(jQuery));
// end of countdown plugin



// dom ready events (would usually be in separate js file)
$(document).ready(function() {
  
  if ( ($.cookie('countdown-cookie') == null)  && ($.cookie('countdown-cookie-exp') == null )  ) {  
      // console.log('no-cookie'); 
      var date = new Date();
	  date.setTime(date.getTime() + (3 * 24 * 60 * 60 * 1000));
      $.cookie('countdown-cookie', date, { path: '/', expires: date });
      $.cookie('countdown-cookie-exp', 'already-had', { path: '/', expires: 666 });
      $('.counter').countdown({targetDate: date});
    $('.product-form-non-disc').remove();

  } else if ( ($.cookie('countdown-cookie') == null) && $.cookie('countdown-cookie-exp') ) {
      // console.log('offer expired'); 
    $('.counter-wrapper').remove();
     $('.product-form-disc').remove(); 
  } else if ( $.cookie('countdown-cookie') )  {
      // console.log('offer valid'); 
      $('.counter').countdown({targetDate: $.cookie('countdown-cookie')});
	  // console.log($.cookie('countdown-cookie'));
    $.cookie('countdown-cookie-exp', 'already-had', { path: '/', expires: 666 });
    $('.product-form-non-disc').remove();
  }
            

});


// var mousewheelevt = (/Firefox/i.test(navigator.userAgent)) ? "DOMMouseScroll" : "mousewheel" //FF doesn't recognize mousewheel as of FF3.x
// $(window).bind(mousewheelevt, function(e){
//     var evt = window.event || e //equalize event object     
//     evt = evt.originalEvent ? evt.originalEvent : evt; //convert to originalEvent if possible               
//     var delta = evt.detail ? evt.detail*(-40) : evt.wheelDelta //check for detail first, because it is used by Opera and FF
//     if(delta > 0) {
//       if(window.innerWidth > 480){
//         $('.header').css('display', 'block')
//       } else {
//         $('#header').css('display', 'block')
//       }
//     } else {
//       if(window.innerWidth > 480){
//         $('.header').css('display', 'none')
//       } else {
//         $('#header').css('display', 'none')
//       }
//     }   
// });

$(document).ready(function() {

  var pageUrl = window.location.href;
  if ($('#facebook-comments').length) {
    $('#facebook-comments').append('<div class="fb-comments" data-href="' + pageUrl + '" data-width="500" data-numposts="5"></div>');
  }

  if ($('#facebook-like-share').length) {
    $('#facebook-like-share').append('<div class="fb-like" data-href="' + pageUrl + '" data-width="" data-layout="standard" data-action="like" data-size="small" data-show-faces="true" data-share="true"></div>');
  }

});